import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import EditTracking from '../editor/EditTracking';

export const initTrackingValues = {
  tracking: {
    multi_image: [
      'shop now - image1',
      'shop now - image2',
      'shop now - image3'
    ],
    multi_button: [
      'shop now - button1',
      'shop now - button2',
      'shop now - button3'
    ],
    multi_sub_button: ['close - button1', 'close - button2', 'close - button3']
  }
};

const SlideFullImageTracking: FC = () => {
  const currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  const tracking = useSelector((state: RootState) => state.trackings.tracking);

  const style = `
.root_tracking{
    width: 100%;
    height: 100%;

    overflow: hidden;
    position: relative;
    

    .close_btn {
        width: 100%;
        // height: 2rem;
      position: absolute;
      top: 6%;
      right: 0;

      display: flex;
      align-items: center;
    }

    .center_wrapper {
      width: 100%;

      display: flex;
      flex-direction: column;
      gap: 1.5rem;

      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .slick_wrapper,
    .slick_wrapper .slick-slider,
    .slick_wrapper .slick-list {
      width: 100%;
      height: 24rem;
    }
    .slick-track {
      position: relative;
    }

    .slider_image_box {
      max-width: calc(14.375rem * 0.8);
      height: calc(24rem * 0.8);
      // margin-top: 2.2rem;

      outline: none;
      transition: all ease 0.3s 0s;
    }
    .slider_image_box {
      max-width: 14.375rem;
      height: 24rem;
      outline: none;
      transition: all ease 0.3s 0s;
      position: relative;
    }
    .slider_image_box img,
    .slider_image_act_box img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      outline: none;
    }

    .modal_wrapper {
      width: 100%
      height: 100%;

      color: #fff;
      font-size: 0.78513rem;
      font-weight: 400;
      font-family: Roboto;
      
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      
      text-align: center;
      display: flex;
      flex-direction: column;
      gap: 2rem;
      justify-content: center;
      align-items: center;
    }

    .contents_wrapper {
      width: 100%;
      height: 8.75rem;
      background: transparent;
    }

    .contents_box .title {
      width: 100%;
      height: 5rem;
      display: flex;
      align-items: center;
    }
    .contents_box .sub_title {
      width: 100%;
      max-height: 3.5rem;
      display: flex;
      align-items: center;
    }

    .bottom_wrapper {
      width: 100%;
      height: 3rem;
      padding: 0;
    }

    .tracking_center {
        display: flex;
        align-items: center;
        justify-content: end;
    }
}
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root_tracking">
        <div className="close_btn tracking_center">
          <EditTracking
            value={tracking?.multi_sub_button?.[currentIndex]}
            type="multi_sub_button"
          />
        </div>
        <div className="center_wrapper">
          <div className="slick_wrapper tracking_center">
            <EditTracking
              value={tracking?.multi_image?.[currentIndex]}
              type="multi_image"
            />
          </div>
          <div className="contents_wrapper" />
          <div className="bottom_wrapper tracking_center">
            <EditTracking
              value={tracking?.multi_button?.[currentIndex]}
              type="multi_button"
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default SlideFullImageTracking;
